export default function TokenUsageBar({ used = 0, total = 0 }) {
  const safeUsed = Number(used) || 0
  const safeTotal = Number(total) || 0
  const pct = safeTotal > 0
    ? Math.min(100, Math.round((safeUsed / safeTotal) * 100))
    : 0
  const color =
    pct >= 90 ? 'from-red-500 to-rose-400' :
    pct >= 70 ? 'from-amber-500 to-yellow-400' :
    'from-violet-500 to-indigo-400'

  const markerColor =
    pct >= 90 ? 'bg-red-400' :
    pct >= 70 ? 'bg-amber-400' :
    'bg-violet-400'

  return (
    <div className="bg-white/[0.04] border border-white/[0.08] rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <p className="text-white/50 text-[11px] uppercase tracking-widest">Uso de Tokens</p>
        <span className={`text-sm font-bold font-mono ${pct >= 90 ? 'text-red-400' : pct >= 70 ? 'text-amber-400' : 'text-violet-400'}`}>
          {pct}%
        </span>
      </div>

      {/* Bar */}
      <div className="relative h-3 bg-white/[0.06] rounded-full overflow-hidden">
        <div
          className={`h-full bg-gradient-to-r ${color} rounded-full transition-all duration-700 ease-out relative`}
          style={{ width: `${pct}%` }}
        >
          {/* Shimmer */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-[shimmer_2s_infinite]" />
        </div>
      </div>

      {/* Labels */}
      <div className="flex items-center justify-between mt-2.5">
        <div className="flex items-center gap-1.5">
          <span className={`w-1.5 h-1.5 rounded-full ${markerColor}`} />
          <span className="text-white/40 text-[11px]">{safeUsed.toLocaleString('pt-BR')} usados</span>
        </div>
        <span className="text-white/30 text-[11px]">{safeTotal.toLocaleString('pt-BR')} total</span>
      </div>

      {pct >= 70 && (
        <div className={`mt-3 flex items-center gap-2 px-3 py-2 rounded-lg text-[11px] ${pct >= 90 ? 'bg-red-500/10 border border-red-500/20 text-red-300' : 'bg-amber-500/10 border border-amber-500/20 text-amber-300'}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 1L11 10H1L6 1Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
            <line x1="6" y1="5" x2="6" y2="7.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
            <circle cx="6" cy="9" r="0.6" fill="currentColor"/>
          </svg>
          {pct >= 90 ? 'Tokens críticos — recarregue agora para evitar interrupções.' : 'Mais de 70% dos tokens utilizados. Considere recarregar em breve.'}
        </div>
      )}
    </div>
  )
}
